module.exports = __webpack_public_path__ + "static/media/instapage12.2e9713c7.png";